module.exports = __webpack_public_path__ + "img/PROUNI.b68398cf.png";